import React, { useState } from 'react';
import './Login.css';
import { validatePasscode } from '../api'

function Login({ onLoginSuccess }) {
  const [passcode, setPasscode] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const data = await validatePasscode(passcode);
      console.log(data);
      if (data && data.company) {
        onLoginSuccess(data.company, data.logo_url);
      } else {
        alert(data.error || 'Incorrect passcode');
      }
    } catch (error) {
      console.error('Login error:', error);
      alert('An error occurred during login');
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleLogin} className="login-form">
        <input
          type="password"
          value={passcode}
          onChange={(e) => setPasscode(e.target.value)}
          placeholder="Enter passcode"
          className="login-input"
        />
        <button type="submit" className="login-button">Login</button>
      </form>
    </div>
  );
}

export default Login;
